import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database, Json } from "@/integrations/supabase/supabaseTypes";
import type { SaveRepository } from "./saveRepository";

const TABLE_NAME = "player_saves";

export function createCloudSaveRepository(
  client: SupabaseClient<Database>,
): SaveRepository {
  return {
    async load(ownerId) {
      const result = await client
        .from(TABLE_NAME)
        .select("save_data, save_version, saved_at")
        .eq("owner_id", ownerId)
        .maybeSingle();
      if (result.error) {
        throw new Error(
          `Failed to load player_saves for owner ${ownerId}: ${result.error.message}`,
        );
      }
      if (result.data === null) {
        return null;
      }
      return result.data.save_data;
    },

    async save(ownerId, saveData) {
      const savedAtIso = new Date(saveData.timestamps.savedAt).toISOString();
      const result = await client.from(TABLE_NAME).upsert(
        {
          owner_id: ownerId,
          save_version: saveData.version,
          save_data: saveData as unknown as Json,
          saved_at: savedAtIso,
        },
        { onConflict: "owner_id" },
      );
      if (result.error) {
        throw new Error(
          `Failed to upsert player_saves for owner ${ownerId}: ${result.error.message}`,
        );
      }
    },
  };
}
